module.exports = __webpack_public_path__ + "img/default_org.faa9ce84.jpg";